import type { ConnectwareError } from '../../domain'

export interface LoggerService {
    warn(message: string, extra?: unknown): void
    info(message: string, extra?: unknown): void
    log(message: string, extra?: unknown): void
    debug(message: string, extra?: unknown): void
    error(error: ConnectwareError): void
}
